module.exports = __webpack_public_path__ + "static/media/IBMPlexMono-Regular.cb46f1f1.ttf";